import styled from '@emotion/styled';

const StyledDiv = styled.div<{ isUrdu: boolean }>`
  direction: ${(props) => (props.isUrdu ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isUrdu ? 'right' : 'left')};
  font-family: ${(props) =>
    props.isUrdu ? "'Gulzar', 'Noto Nastaliq Urdu', serif" : 'inherit'};
  line-height: ${(props) => (props.isUrdu ? '2.75' : 'inherit')};
  letter-spacing: ${(props) => (props.isUrdu ? '1px' : 'inherit')};
`;

export const AlignUrduWrapper = (props: {
  isUrdu: boolean;
  children?: React.ReactNode;
  [key: string]: any;
}) => {
  const { isUrdu, children, ...rest } = props;
  return (
    <StyledDiv {...rest} isUrdu={isUrdu} dir={isUrdu ? 'rtl' : 'ltr'}>
      {children}
    </StyledDiv>
  );
};
